var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.icon)?_c('base-button',{class:[
  'align-middle',
  _vm.status > 0 ? (
    _vm.status == 9999 ? 'text-red-500 hover:text-red-600' : 'text-yellow-500 hover:text-yellow-600'
  ) : 'text-gray-400 hover:text-gray-500'
],attrs:{"small":"","icon":"","title":"Ban / Warn User"},on:{"click":_vm.trigger}},[_c('BanIcon',{staticClass:"w-5 h-5"})],1):_c('base-button',{attrs:{"small":"","type":"danger","title":"Ban / Warn User"},on:{"click":_vm.trigger}},[_c('BanIcon',{staticClass:"w-5 h-5 align-middle"}),_vm._v("   Ban User")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }